import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import AddQA from './sections/add';
import EditQA from './sections/edit';


const QA = () => {
    const [qa, setQA] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [qaId, setQaId] = useState(null);
    const [filterText, setFilterText] = useState('');

    const fetchQA = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/qa?page=${currentPage + 1}`)
            .then(response => {
                setQA(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching the qa!", error);
                setQA([]);
            });
    };

    useEffect(() => {
        fetchQA(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = qa.filter(
        item => item.project_name.toLowerCase().includes(filterText.toLowerCase())
    );

    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">QA</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">QA</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_qa"><i
                                    className="fa-solid fa-plus"></i> Add QA</Link>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <input className="form-control" id="search_Input" type="text"
                            placeholder="Search project..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table adminData">
                                        <thead>
                                            <tr>
                                                <th>Channel</th>
                                                <th>Client</th>
                                                <th>Project</th>
                                                <th>Manager/Team Lead</th>
                                                <th>Assigned Tester</th>
                                                <th>Description</th>
                                                <th>Current Status</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((qa) => (
                                                        <tr key={qa.id}>
                                                            <td>{qa.channel}</td>
                                                            <td>{qa.client}</td>
                                                            <td>{qa.project_name}</td>
                                                            <td>{qa.task_incharge_name}</td>
                                                            <td>{qa.tester_name}</td>
                                                            <td>{qa.description}</td>
                                                            <td>{qa.status_name}</td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setQaId(`${qa.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_qa_${qa.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                            {/* <DeleteComponent 
                                                                                url = "qa"
                                                                                id = {qa.id}
                                                                                fetchData={fetchQA} /> */}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddQA list={fetchQA}/>
            <EditQA list={fetchQA} qaId={qaId} />
        </>
    );
}

export default QA